const OPEN_MISSION = 'mission'
const OPEN_MIDEA_MEETING = 'midea-meeting'

export {
  OPEN_MISSION,
  OPEN_MIDEA_MEETING
}
